import { Component, ViewEncapsulation } from '@angular/core';
import { SystemMessages } from '@portal-core/system-messages/components/system-messages';
import { SystemMessageType } from '@portal-core/system-messages/enums/system-message-type.enum';
import { SystemMessage } from '@portal-core/system-messages/models/system-message.model';
import { MatNavList, MatListItem } from '@angular/material/list';
import { NgFor, NgClass, AsyncPipe } from '@angular/common';

@Component({
    selector: 'mc-system-message-list',
    templateUrl: './system-message-list.component.html',
    styleUrls: ['./system-message-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [MatNavList, NgFor, MatListItem, NgClass, AsyncPipe]
})
export class SystemMessageListComponent extends SystemMessages {
  getMessageColorClassName(message: SystemMessage): string {
    return message.Type === SystemMessageType.WhatsNew ? 'mc-whats-new-link' : 'mc-system-message-link';
  }
}
